import { Box, TableCell, TableFooter, TableRow, Typography } from "@material-ui/core";
import { FC } from "react";
import { shallowEqual } from "react-redux";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useStyles } from "./styles";
import { getScheduleFooterValue } from "utils/scheduleHelpers";
import { formatNumberType } from "utils/formatNumbers";

interface PropsType {
  tableNumber: number;
  headerColumns: any;
  rows: any;
}

const ScheduleTableFooter: FC<PropsType> = ({ tableNumber, headerColumns, rows }) => {
  const classes = useStyles();
  const { userList, dataList, scheduleFilters } = useTypeSelectors((state) => state.scheduleTable, shallowEqual);

  const tenuredCount = userList
    ?.filter((user) => user.tenured >= 30)
    ?.filter((user) =>
      dataList.some(
        (schedule) => schedule.assigned_to === user.id && [0, 8].includes(schedule.role),
      ),
    ).length;

  const roleCount = userList?.filter((user) =>
    dataList.some((schedule) => schedule.assigned_to === user.id && [0, 8].includes(schedule.role)),
  ).length;

  return (
    <TableFooter className={classes.tableFooter}>
      <TableRow>
        {tableNumber === 1 && <TableCell className={`${classes.tableFooterCell} ${classes.tableBorderLeft}`} />}
        {headerColumns.map((col: any, index: number) => (
          <TableCell
            key={`footer-${col.id}`}
            className={`${classes.tableFooterCell} ${index === 0 ? "" : classes.tableBorderLeft}`}
          >
            <Box className={classes.footerBox}>
              {col.id === "user" && <PersonOutlinedIcon className={classes.footerIcon} />}
              {(col.id === "hours" || col.dateCol) && (
                <AccessTimeOutlinedIcon className={classes.footerIcon} />
              )}
              {col.id !== "tenured" ? (
                <Typography>{getScheduleFooterValue(col.id, scheduleFilters.station, col.date, rows, dataList)}</Typography>
              ) : (
                <Typography>
                  {isNaN(formatNumberType((tenuredCount * 100) / roleCount))
                    ? 0
                    : formatNumberType((tenuredCount * 100) / roleCount)}
                  %
                </Typography>
              )}
            </Box>
          </TableCell>
        ))}
      </TableRow>
    </TableFooter>
  );
};

export default ScheduleTableFooter;
